import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import Style from './index.less';
import Close from '../../../frame/components/property-editor/images/close.svg';
import { isTestEnvId, isLocalDebug } from '../../../../js/common/utils';
import Snackbar from '@tencent/dui/lib/components/Snackbar';
import i18n from '@i18next/i18n';
import userLocalStorage, { LocalStorageKeys } from '@src/slide/infrastructure/module/independent/local-storage';

const MID = 'PerformanceStats';

interface PerformanceStatsProps {}

interface PerformanceStatsState {
    left: number;
    top: number;
    memoryText: string;
    fpsText: string;
}

export default class PerformanceStats extends Component<PerformanceStatsProps, PerformanceStatsState> {
    private static PerformanceInstance: PerformanceStats | null = null;
    public static autoShow(config = null) {
        const show = userLocalStorage.getItem(LocalStorageKeys.SAVED_SHOW, true);
        if (show) {
            PerformanceStats.showPerformanceStats(config);
        }
    }

    /**
     * 显示时创建
     * @param config
     */
    public static showPerformanceStats(config = null) {
        if (!window.performance || (window.performance && !performance.memory)) {
            // eslint-disable-next-line @tencent/i18next/no-literal-string
            console.warn(i18n.t('不支持performance.memory'));
        }

        // 是非本地开发环境，并且是正式环境且测试环境id不等于3
        console.log('test env?', isTestEnvId(), isLocalDebug());
        if (!isLocalDebug() && (!isTestEnvId())) {
            return;
        }

        if (!this.PerformanceInstance) {
            const div = document.createElement('div');
            div.id = MID;
            document.body.appendChild(div);
            // @ts-ignore
            // eslint-disable-next-line react/no-render-return-value
            this.PerformanceInstance = ReactDOM.render(<PerformanceStats />, div);
        }

        this.PerformanceInstance?.show(config);
    }

    /**
     * 隐藏后销毁
     */
    public static hidePerformanceStats() {
        if (this.PerformanceInstance) {
            this.PerformanceInstance.hide();

            const div = document.getElementById(MID);
            if (div) {
                div.remove();
            }
            this.PerformanceInstance = null;
        }
    }

    private refresh: boolean;
    private prevTime: number;
    private frames: number;
    private prevMemoryTime: number;
    private dragObj: {
        rect: DOMRect; isDragging: boolean; clientX: number | null;
        clientY: number | null; offsetX: number; offsetY: number;
    };

    public constructor(props: PerformanceStatsProps) {
        super(props);

        let left = 2;
        let top = 2;
        const savedObj = userLocalStorage.getItem(LocalStorageKeys.SAVED);
        if (savedObj) {
            left = savedObj.left || left;
            top = savedObj.top || top;
        }

        this.state = {
            left,
            top,
            memoryText: '0M',
            fpsText: '60',
        };

        this.refresh = true;
        this.prevTime = 0;
        this.frames = 0;
        this.prevMemoryTime = 0;
    }

    public componentDidMount() {
        // eslint-disable-next-line @typescript-eslint/no-this-alias
        const page = this;
        requestAnimationFrame(function rAFloop() {
            if (page.refresh) {
                page.updateFps();
                page.updateMemory();
                requestAnimationFrame(rAFloop);
            }
        });
    }

    public componentWillUnmount() {
        this.refresh = false;
    }

    public render() {
        const style = { left: this.state.left, top: this.state.top };

        return (
            <div id={'stats'} className={Style.memory_container} style={style} onMouseDown={this.handleDragStart}>
                <div className={Style.memory_title_bar}>
                    <img className={Style.close_icon}
                        src={Close}
                        onClick={this.close}
                        onMouseDown={e => e.stopPropagation()}/>
                </div>
                <div className={Style.memory_text}>Mem: {this.state.memoryText}</div>
                <div className={Style.memory_text}>FPS: {`  ${this.state.fpsText}`}</div>
            </div>
        );
    }
    public show = (config) => {
        if (config) {
            this.setState({
                left: config.left,
                top: config.top,
            });
        }
    };

    public hide = () => {
        this.refresh = false;
    };

    private updateFps = () => {
        this.frames += 1;
        const time = new Date().getTime();
        const first = this.prevTime === 0;
        if (time >= this.prevTime + 1000) {
            const fps = parseInt(`${(this.frames * 1000) / (time - this.prevTime)}`, 10);
            this.prevTime = time;
            this.frames = 0;

            if (!first) {
                this.setState({
                    fpsText: `${fps}`,
                });
            }
        }
    };

    private updateMemory = () => {
        const time = new Date().getTime();
        if (time >= this.prevMemoryTime + 500) {
            this.prevMemoryTime = time;
            let usedJSHeapSize = 0;
            if (window.performance && performance.memory) {
                usedJSHeapSize = performance.memory.usedJSHeapSize;
            }
            const memoryText = usedJSHeapSize === 0 ? '0' : this.bytesToSize(usedJSHeapSize);
            this.setState({
                memoryText,
            });
        }
    };

    private bytesToSize(bytes: number, nFractDigit?: number): string {
        const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB'];
        if (bytes === 0) return 'n/a';
        nFractDigit = nFractDigit !== undefined ? nFractDigit : 0;
        const precision = Math.pow(10, nFractDigit);
        const i = Math.floor(Math.log(bytes) / Math.log(1024));
        return `${Math.round(bytes * precision / Math.pow(1024, i)) / precision} ${sizes[i]}`;
    }

    private close = () => {
        userLocalStorage.setItem(LocalStorageKeys.SAVED_SHOW, false);
        PerformanceStats.hidePerformanceStats();
        Snackbar.show({
            type: 'info',
            message: i18n.t('可在 菜单-文件-开发者工具 中再次打开'),
        });
    };

    private addDragListener = () => {
        document.addEventListener('mousemove', this.handleDragging);
        document.addEventListener('mouseup', this.handleDragStop);
    };

    private removeDragListener = () => {
        document.removeEventListener('mousemove', this.handleDragging);
        document.removeEventListener('mouseup', this.handleDragStop);
    };

    private handleDragStart = (e: React.MouseEvent<HTMLDivElement>) => {
        if (e.currentTarget) {
            this.addDragListener();
            const rect = e.currentTarget.getBoundingClientRect();
            const offsetX = e.clientX - rect.left;
            const offsetY = e.clientY - rect.top;
            this.dragObj = {
                rect,
                isDragging: false,
                clientX: e.clientX,
                clientY: e.clientY,
                offsetX,
                offsetY,
            };
        }
    };

    private handleDragging = (e: MouseEvent) => {
        if (this.dragObj.clientX === e.clientX && this.dragObj.clientY === e.clientY) {
            this.dragObj.clientX = null;
            this.dragObj.clientY = null;
        } else {
            const { rect } = this.dragObj;
            this.dragObj.isDragging = true;
            this.changeFrame(e.clientX, e.clientY, this.dragObj.offsetX, this.dragObj.offsetY, rect, false);
        }
    };

    private handleDragStop = (e: MouseEvent) => {
        if (this.dragObj.isDragging) {
            const { rect } = this.dragObj;
            this.dragObj.isDragging = true;
            this.changeFrame(e.clientX, e.clientY, this.dragObj.offsetX, this.dragObj.offsetY, rect, true);
        }
        this.dragObj.isDragging = false;

        this.removeDragListener();
    };

    private changeFrame = (
        clientX: number, clientY: number, offsetX: number,
        offsetY: number, rect: DOMRect, saved: boolean,
    ) => {
        const w = document.body.clientWidth;
        const h = document.documentElement.clientHeight;
        let left = clientX - offsetX;
        left = left > (w - (rect.width / 2)) ? (w - (rect.width / 2)) : left;
        left = left < -rect.width / 2 ? -rect.width / 2 : left;

        let top = clientY - offsetY;
        top = top > (h - (rect.height / 2)) ? (h - (rect.height / 2)) : top;
        top = top < -rect.height / 2 ? -rect.height / 2 : top;

        this.setState({
            left,
            top,
        });

        if (saved) {
            userLocalStorage.setItem(LocalStorageKeys.SAVED, { left, top });
        }
    };
}
